import { render, staticRenderFns } from "./AIAgent.MessageService.vue?vue&type=template&id=4ff011e9&lang=pug"
import script from "./AIAgent.MessageService.vue?vue&type=script&lang=js"
export * from "./AIAgent.MessageService.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.MessageService.vue?vue&type=style&index=0&id=4ff011e9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports